export default "__VITE_ASSET__CNA6b4PX__"